import 'sharer.js';

class AddThisToolbox {
	
	constructor(el){
		this.el = el;
		this.el.style.display = 'inline-flex !important';
		// replace add_this with 'sharer'
		this.title = this.el.getAttribute('addthis:title') || document.title;
		this.url = this.el.getAttribute('addthis:url') || window.location.href;
		this.links = this.el.querySelectorAll('a');
		this.updateLinks();

	}

	updateLinks(){
		this.links.forEach( a => {
			const matches = a.className.match(/(^|\s)addthis_button_(.+?)(\s|$)/);
			a.setAttribute('data-sharer', matches[2]);
			a.setAttribute('data-title', this.title);
			a.setAttribute('data-url', this.url );
			// a.setAttribute('data-blank', 'true');
		});

		window.Sharer.init();
	}

}

const instances = [];
export default {
	instances,
	init(el){
        instances.push( new AddThisToolbox(el) );
    }
}